import { Reducer } from '@reduxjs/toolkit';
import { ActionType, ActionConstructor } from './types';
import { EMPTY_OBJECT } from '~/constants';
import { pipe } from '~/utils/function';
import { isEqual } from '~/utils/object';

export const createActions = (config: any) => {
  const types: { [x: string]: string } = {};
  const actions: { [x: string]: ActionConstructor } = {};
  Object.keys(config).forEach((action: string) => {
    types[action] = action;
    // todo: enforce action params
    actions[action] = (params?: any) => ({
      type: action,
      payload: params || EMPTY_OBJECT,
      meta: EMPTY_OBJECT,
    });
    // }
  });

  return {
    Types: types,
    Actions: actions,
  };
};
// see also combineReducers from the redux package

export const mergeReducers =
  (reducers: Reducer<any, ActionType>[]) =>
  (initialState: any, action: ActionType) => {
    const composableReducers = reducers.map(
      (reducer: Reducer<any, ActionType>) => (state: any) =>
        reducer(state, action),
    );
    return pipe(...composableReducers)(initialState);
  };

export const isPayloadEmpty = (param: any): boolean =>
  isEqual(param, EMPTY_OBJECT);
